import classnames from "classnames";
import "devices.css/dist/devices.min.css";
import type { FunctionComponent, ReactElement, ReactNode } from "react";
import { Children, cloneElement, isValidElement } from "react";

import { DeviceButtons, DeviceContainer, DeviceFrame, DevicePower, DeviceStripe } from "./styles";

export type Props = {
  children: ReactNode;
  className?: string;
} & (
  | {
      color: "purple" | "silver" | "black" | "gold";
      device: "iphone-14-pro";
    }
  | {
      color: "midnight" | "purple" | "starlight" | "red" | "blue";
      device: "iphone-14";
    }
);

export const DeviceFrameset: FunctionComponent<Props> = ({
  children,
  className,
  color = "silver",
  device = "iphone-14",
}) => {
  const childrenWithClassName = () =>
    Children.map(children, child => {
      if (isValidElement(child)) {
        return cloneElement(child as ReactElement<{ className: string }>, {
          className: `device-screen`,
        });
      }
      return child;
    });

  return (
    <DeviceContainer
      className={classnames(
        {
          [`device-${device}`]: true,
          [`device-${color}`]: true,
          device: true,
        },
        className,
      )}
    >
      <DeviceFrame className="device-frame">{childrenWithClassName()}</DeviceFrame>
      <DeviceStripe className="device-stripe" />
      <DeviceButtons className="device-btns" /> {/** cspell: disable-line */}
      <DevicePower className="device-power" />
    </DeviceContainer>
  );
};

DeviceFrameset.displayName = "DeviceFrameset";
